<script>
    import Image from "./Image.svelte";
    import Button from "./Button.svelte";
    import Checkbox from "../../Common/Checkbox.svelte";
    import {M} from "../../external";

    export let data;

    $: if (!data.buttonStyle) data.buttonStyle = {};
</script>

<Checkbox bind:data={data.switched} label={M.SWITCH_SIDE}/>
<Image bind:data={data} disable={['fullscreen', 'link', 'width']}/>
<Button bind:data={data} isCollapsable={true} isCollapsed={true}/>